export const verifyPayment = async (paymentId) => {
  try {
    if (!paymentId || typeof paymentId !== "string") {
      console.error("Invalid payment ID");
      return false;
    }

    console.log("Starting payment verification for ID:", paymentId);

    const functionURL = "https://verifypayment-qwfnnmalla-uc.a.run.app";
    const timeout = 10000; // 10 seconds timeout

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await fetch(functionURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ paymentId }),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      console.log("payment response -> ", response);

      if (!response.ok) {
        throw new Error(`Verification failed: HTTP ${response.status}`);
      }

      const result = await response.json();
      if (result.success) {
        console.log("✅ Payment Verified:", paymentId);
        return true;
      } else {
        console.warn("Payment verification failed:", result);
        return false;
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.error("Verification timed out");
        return false;
      }
      throw error;
    }
  } catch (error) {
    console.error("Error verifying payment:", error);
    return false;
  }
};
